/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import Hover from "../../components/hover";
import EditDate from "./EditDate";
import { Loading } from "./AllReports";
import { dateFormatForArrays } from "../../utils/helpers";
import { cpt30Pro, cpt90Pro, deviceType } from "../../utils/helpers";

const PayerType = (type, item) => {
  if (!type) console.log(item);
  return <Hover onHover={type}>{type?.slice(0, 1)}</Hover>;
};

const PreAuthTable = ({ data, initialLoad }) => {
  return (
    <div className="contentTbl">
      <table className="overview" id="data-table">
        <thead>
          <tr>
            <th>Last, First</th>
            <th>DOB</th>
            <th>MRN</th>
            <th>
              Device <br /> Type
            </th>
            <th>
              Payer <br /> Type
            </th>
            <th>
              Insurance <br /> Type
            </th>
            <th>cpt30</th>
            <th>30DOS</th>
            <th>cpt90</th>
            <th>90DOS</th>
            <th>
              Insurance Policy <br /> Name
            </th>
            <th>Policy #</th>
            <th>Group #</th>
            <th>
              Last <br /> Preauth30
            </th>
            <th>
              Last <br /> Preauth90
            </th>
          </tr>
        </thead>

        {initialLoad ? (
          <Loading colspan="18" />
        ) : data.length > 0 ? (
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{`${item?.patientFamily}, ${item?.patientName}`}</td>
                <td>{item?.patientDOB ? new Date(item?.patientDOB).toShortDateFormat() : "-"}</td>
                <td>{item?.patientMRN}</td>
                <td>{deviceType(item?.deviceType)}</td>
                <td>{PayerType(item?.insurancePayerType, item)}</td>
                <td>{item?.insuranceType}</td>
                <td style={{ minWidth: 80 }}>
                  Pro: {cpt30Pro(item.deviceType, item?.remoteMonitoring30CycleEndDay)} <br /> Tec: 93299
                </td>
                <td>
                  {item?.remoteMonitoring30CycleEndDay
                    ? new Date(item?.remoteMonitoring30CycleEndDay).addDays(1).toShortDateFormat()
                    : "-"}
                </td>
                <td style={{ minWidth: 80 }}>
                  Pro:{" "}
                  {cpt90Pro(
                    item.deviceType,
                    item?.remoteMonitoring90CycleEndDay,
                    item?.remoteMonitoring30CycleEndDay
                  )}{" "}
                  <br /> Tec:{" "}
                  {!item?.remoteMonitoring30CycleEndDay && item?.remoteMonitoring90CycleEndDay ? 93296 : "-"}
                </td>
                <td>
                  {item?.remoteMonitoring90CycleEndDay
                    ? new Date(item?.remoteMonitoring90CycleEndDay).addDays(1).toShortDateFormat()
                    : "-"}
                </td>
                <td>{item?.insuranceName}</td>
                <td>{item?.insurancePolicyNumber}</td>
                <td>{item?.insuranceTypeGroupNumber}</td>
                <td>
                  <EditDate
                    value={
                      item?.remoteMonitoring30CyclePreAuth &&
                      dateFormatForArrays(item?.remoteMonitoring30CyclePreAuth)
                    }
                    patientId={item?.id}
                    type="poauthTh"
                  />
                </td>
                <td>
                  <EditDate
                    value={
                      item?.remoteMonitoring90CyclePreAuth &&
                      dateFormatForArrays(item?.remoteMonitoring90CyclePreAuth)
                    }
                    patientId={item?.id}
                    type="poauthNi"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        ) : null}
      </table>
      {data.length === 0 && !initialLoad ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
            fontSize: 18,
          }}
        >
          No patients
        </div>
      ) : null}
    </div>
  );
};

export default PreAuthTable;
